import { jsxs as u, jsx as a } from "react/jsx-runtime";
import { useBreakpoint as c, Breakpoints as n } from "@nextgen-web-framework/all";
import m from "../LanguageModal/LanguageModal.js";
import p from "../../utils/useLanguageSelector.js";
import '../../assets/MePanelLanguage.css';const k = {
  "me-panel-language-container": "_me-panel-language-container_jkplg_1",
  "language-modal-side-wrapper": "_language-modal-side-wrapper_jkplg_4"
}, w = ({ children: o, locale: t, langHandler: l }) => {
  const { showLanguageModal: r, onCloseHandler: g, languageClickHandler: e, handleLanguageChange: s } = p({
    langHandler: l
  }), d = c(), i = [n.SM, n.XS].includes(d);
  return /* @__PURE__ */ u("div", { className: k["me-panel-language-container"], "data-testid": "me-panel-language-test-id", "data-pod-name": "commerce", children: [
    /* @__PURE__ */ a(
      "div",
      {
        onKeyDown: e,
        onClick: e,
        role: "presentation",
        "data-testid": "language-button-test-id",
        "data-pod-name": "commerce",
        children: o
      }
    ),
    r && /* @__PURE__ */ a(
      m,
      {
        hasBackButton: !i,
        languageHandler: s,
        currentLocale: t,
        onClose: g
      }
    )
  ] });
};
export {
  w as default
};
//# sourceMappingURL=MePanelLanguage.js.map
